import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import "./ClinicScreen.css";
import FilterUsers from "./FilterUsers";
import ShowData from "./ShowData";
import { providerAssessmentAction } from "../../redux/actions/providerActions";
import Content from "../../components/Content";
import {
  getProductCategory,
  getQuizResultsList,
} from "../../redux/actions/quizActions";
import { GET_QUIZ_FILTER_RESULTS_RESET } from "../../redux/constants/quizResults";
import { logout } from "../../redux/actions/userActions";

const QuizResults = ({ history }) => {
  const dispatch = useDispatch();

  const clinicProvider = useSelector((state) => state.clinicProvider);
  const clinicFilter = useSelector((state) => state.clinicFilter);
  const quizResultsFilterList = useSelector(
    (state) => state.quizResultsFilterList
  );

  const [quizResultsList, setQuizResultsList] = useState([]);
  const userLogin = useSelector((state) => state.userLogin);
  const [productsCategory, setProductsCategory] = useState([]);

  const [userIndex, setUserIndex] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState(1);
  const [showFilter, setShowFilter] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const pageLimit = 10;
  let pageNo = totalPageSize / pageLimit;

  const [filterData, setFilterData] = useState({
    email: "",
    productId: "",
    firstName: "",
    lastName: "",
    birthDate: "",
    pageNumber: pageNumber,
    rowsOfPage: 10,
  });

  const getProductHandler = React.useCallback(async () => {
    if (userLogin && userLogin.userInfo && userLogin.userInfo.token) {
      const data = await dispatch(getProductCategory(userLogin));
      if (data?.data) {
        setProductsCategory(data.data);
      }
    }
  }, [dispatch, userLogin]);

  React.useEffect(() => {
    getProductHandler();
  }, [getProductHandler]);

  const getQuizResultHandler = React.useCallback(async () => {
    if (userLogin && userLogin.userInfo && userLogin.userInfo.token) {
      getQuizResultsData(pageNumber);
    }
  }, [dispatch, userLogin]);

  React.useEffect(() => {
    getQuizResultHandler();
  }, [getQuizResultHandler]);

  useEffect(() => {
    debugger;
    if (
      quizResultsFilterList &&
      quizResultsFilterList.data &&
      quizResultsFilterList.data.data &&
      quizResultsFilterList.data.data.length > 0
    ) {
      setQuizResultsList(quizResultsFilterList.data.data);
      setTotalPageSize(quizResultsFilterList.data.data[0].totalCount);
    } else if (
      quizResultsFilterList &&
      quizResultsFilterList.error &&
      quizResultsFilterList.error.status === 501
    ) {
      dispatch(logout());
      history.push("/login");
    }
  }, [quizResultsFilterList, dispatch, history]);

  useEffect(() => {
    return () => {
      dispatch({ type: GET_QUIZ_FILTER_RESULTS_RESET });
    };
  }, [dispatch]);

  const handleAssessment = (id) => {
    dispatch(providerAssessmentAction(id));
  };

  const handleFilter = () => {
    var formData = {
      email: filterData.email,
      clinicId: filterData.clinicId,
      productId: filterData.productId,
      firstName: filterData.firstName,
      lastName: filterData.lastName,
      birthDate: filterData.birthDate,
      pageNumber: 1,
      rowsOfPage: 10,
    };
    setUserIndex(1);
    setPageNumber(1); 
    setQuizResultsList([]);
    dispatch(getQuizResultsList(formData));
  };

  const handleClear = () => {
    setFilterData({
      email: "",
      productId: "",
      firstName: "",
      lastName: "",
      birthDate: "",
      pageNumber: 1,
      rowsOfPage: 10,
    });
    setPageNumber(1);
    setQuizResultsList([]);
    dispatch(getQuizResultsList({ pageNumber, pageLimit }));
  };

  const handlePageChange = async (currentPage) => {
    const selectedPage = currentPage.selected;
    getQuizResultsData(selectedPage + 1);
    setPageNumber(selectedPage + 1);
  };

  const getQuizResultsData = (selectedPage) => {
    let data = {};
    if (filterData.email) {
      data.email = filterData.email;
    }

    if (filterData.productId) {
      data.productId = filterData.productId;
    }

    if (filterData.firstName) {
      data.firstName = filterData.firstName;
    }

    if (filterData.lastName) {
      data.lastName = filterData.lastName;
    }

    if (filterData.birthDate) {
      data.birthDate = filterData.birthDate;
    }

    if (filterData.assessments) {
      data.recentAssessments = filterData.assessments;
    }
    data.pageNumber = selectedPage;
    data.rowsOfPage = pageLimit;
    setQuizResultsList([]);
    dispatch(getQuizResultsList(data));
  };

  return (
    <Content
      current="Patient Quiz Results"
      headerTitle="Patient Quiz Results"
      currentMenu="Patient Quiz Results"
    >
      <FilterUsers
        data={{
          showFilter,
          setShowFilter,
          clinicProvider,
          productsCategory,
          handleClear,
          filterData,
          setFilterData,
          handleFilter,
        }}
      />

      <ShowData
        data={{
          clinicFilter,
          showFilter,
          handleAssessment,
          quizResultsList,
          userIndex,
        }}
        pageNumber={pageNumber}
        pageLimit={pageLimit}
        loading={quizResultsFilterList && quizResultsFilterList.loading}
      />

      {quizResultsList && quizResultsList.length > 0 && (
        <div className="tableContainer--paginater">
          <ReactPaginate
            nextClassName={""}
            previousLabel={"<"}
            nextLabel={">"}
            pageCount={pageNo}
            onPageChange={handlePageChange}
            marginPagesDisplayed={1}
            pageRangeDisplayed={5}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttn"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
            forcePage={pageNumber - 1}
          />
        </div>
      )}
    </Content>
  );
};

export default QuizResults;
